import { render } from "./GdprPage.vue?vue&type=template&id=4a505bc8"
import script from "./GdprPage.vue?vue&type=script&lang=js"
export * from "./GdprPage.vue?vue&type=script&lang=js"

import "./GdprPage.vue?vue&type=style&index=0&id=4a505bc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__